import type { ThemeDefinition } from './types';

export const newspaper: ThemeDefinition = {
  variables: {
    '--report-font-display': "'Times New Roman', Times, Georgia, serif",
    '--report-font-body': "'Times New Roman', Times, Georgia, serif",
    '--report-bg': '#fffff8',
    '--report-bg-surface': '#f8f8f0',
    '--report-text': '#1a1a1a',
    '--report-text-secondary': '#3d3d3d',
    '--report-text-muted': '#777777',
    '--report-accent': '#1a1a1a',
    '--report-accent-dim': 'rgba(26, 26, 26, 0.06)',
    '--report-border': '#d4d4d4',
    '--report-border-strong': '#1a1a1a',
    '--report-stat-color': '#1a1a1a',
    '--report-stat-positive': '#16a34a',
    '--report-stat-negative': '#dc2626',
    '--report-callout-bg': '#f8f8f0',
    '--report-callout-border': '#1a1a1a',
    '--report-surface-hover': '#eeeedf',
    '--report-measure': '780px',
  },
};
